import React from 'react';
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import css from './TabLink.module.scss'

const TabLink = ({text, route, isTab}) => {
  const tabCss = isTab ? css.tab : css.link
  return (
    <div className={`${css.linkCss} ${tabCss}`}>
      <Link to={route}>{text}</Link>
    </div>
  )
}

TabLink.propTypes = {
  text: PropTypes.string.isRequired,
  route: PropTypes.string.isRequired,
  isTab: PropTypes.bool
}

TabLink.defaultProps = {
  isTab: false
}

export default TabLink;
